import React from "react";
import SingleTripRequestContent from "../components/leads/single-trip-request-content";

const SingleTripRequest = () => {
  return <SingleTripRequestContent />;
};

export default SingleTripRequest;
